/**
 * Database type.
 */
export type DatabaseType = "sqlite" | "cordova" | "sqljs" | "websql";
